










import { defineComponent } from "@vue/composition-api";
import BaseSwitch from "@/components/BaseSwitch";

export default defineComponent({
  name: "PublicAccessToggle",
  components: { BaseSwitch },
  props: {
    value: { type: Boolean, default: false },
  },
});
